<template>
  <v-col cols="12" md="4">
    <h4 class="ma-3">Imagem do Aluno</h4>

    <v-hover v-slot="{ hover }">
      <v-card
        class="aluno-image-card mx-auto"
        :elevation="hover ? 12 : 2"
        :class="{ 'on-hover': hover }"
      >
        <v-img :src="imgAlunoCard" height="205px" width="205px" contain>
          <v-card-title v-if="temImagemReal" class="text-h6 white--text">
            <v-row class="fill-height flex-column" justify="space-between">
              <div class="align-self-center">
                <v-btn
                  style="margin-bottom: 10px"
                  @click="abrirImagem(imgAluno)"
                  :class="{ 'show-btns-down': hover }"
                  :color="transparent"
                  plain
                >
                  <v-icon :class="{ 'show-btns-down': hover }" :color="transparent">
                    file_download
                  </v-icon>
                  Baixar
                </v-btn>
                <v-btn
                  @click="removerImagemAluno"
                  :class="{ 'show-btns': hover }"
                  :color="transparent"
                  plain
                >
                  <v-icon :class="{ 'show-btns': hover }" :color="transparent">delete</v-icon>
                  Remover
                </v-btn>
              </div>
            </v-row>
          </v-card-title>
        </v-img>
      </v-card>
    </v-hover>

    <v-file-input
      v-model="fileImagemAluno"
      accept="image/jpeg,image/jpg"
      :max-size="2097152"
      class="mt-5"
      label="Imagem do Aluno"
      hint="Envie apenas arquivos JPG ou JPEG com ate 2 MB."
      persistent-hint
      filled
      prepend-icon="mdi-camera"
      outlined
      show-size
      @change="uploadImagemAluno($event)"
    />

    <e-modal-cortar-imagem
      :dialogProp="cortarImagemDialogAluno"
      :img="imgAluno"
      @atualizar-imagem-aluno="atualizarImagemAluno($event)"
    />
  </v-col>
</template>

<script>
import EModalCortarImagem from "./EModalCortarImagem.vue";

const PLACEHOLDER_IMAGE = `data:image/svg+xml;utf8,${encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="205" height="205" viewBox="0 0 205 205">
  <rect width="205" height="205" fill="#f3f4f6"/>
  <circle cx="102.5" cy="78" r="34" fill="#cbd5e1"/>
  <path d="M43 176c10-28 34-44 59.5-44S152 148 162 176" fill="#cbd5e1"/>
</svg>`)}`;

export default {
  name: "EUploadsImages",
  components: { EModalCortarImagem },
  props: {
    dadosImgAluno: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    fileImagemAluno: null,
    imgAluno: PLACEHOLDER_IMAGE,
    imgAlunoCard: PLACEHOLDER_IMAGE,
    cortarImagemDialogAluno: false,
    transparent: "rgba(255, 255, 255, 0)",
    placeholderImage: PLACEHOLDER_IMAGE,
  }),
  computed: {
    temImagemReal() {
      return this.imgAlunoCard && this.imgAlunoCard !== this.placeholderImage;
    },
  },
  watch: {
    dadosImgAluno: {
      immediate: true,
      handler(value) {
        this.imgAluno = value || this.placeholderImage;
        this.imgAlunoCard = value || this.placeholderImage;
      },
    },
  },
  methods: {
    abrirImagem(img) {
      if (img && img !== this.placeholderImage) {
        window.open(img, "_blank");
      }
    },
    removerImagemAluno() {
      this.fileImagemAluno = null;
      this.imgAluno = this.placeholderImage;
      this.imgAlunoCard = this.placeholderImage;
      this.$emit("imagem-aluno-form", { url: "", name: "" });
    },
    arquivoEhJpeg(file) {
      const tiposPermitidos = ["image/jpeg", "image/jpg"];
      const nome = file?.name?.toLowerCase() || "";
      return tiposPermitidos.includes(file.type) || nome.endsWith(".jpg") || nome.endsWith(".jpeg");
    },
    mostrarErroFormato() {
      this.$modals.info({
        title: "Formato invalido",
        message: "Envie apenas imagens JPG ou JPEG com no maximo 2 MB.",
        buttons: [
          {
            text: "Fechar",
            callback: () => this.$modals.close(),
            props: {
              color: "primary",
              small: true,
            },
          },
        ],
      });
    },
    async uploadImagemAluno(file) {
      if (!file) {
        return;
      }

      if (!this.arquivoEhJpeg(file)) {
        this.fileImagemAluno = null;
        this.mostrarErroFormato();
        return;
      }

      if (file.size > 2097152) {
        this.fileImagemAluno = null;
        this.mostrarErroFormato();
        return;
      }

      try {
        const data = await this.$services.alunosService.uploadImageAluno(file);
        if (!data.nameFile) {
          this.cortarImagemDialogAluno = false;
          this.imgAluno = this.placeholderImage;
          this.imgAlunoCard = this.placeholderImage;
          return;
        }

        this.imgAluno = data.nameFile;
        this.cortarImagemDialogAluno = true;
      } catch (error) {
        this.$handleError(error);
        this.fileImagemAluno = null;
      }
    },
    atualizarImagemAluno(dado) {
      this.imgAluno = dado.url || this.placeholderImage;
      this.imgAlunoCard = this.imgAluno;
      this.cortarImagemDialogAluno = false;
      this.$emit("imagem-aluno-form", dado);
    },
  },
};
</script>

<style scoped>
.aluno-image-card {
  width: 205px;
  transition: opacity 0.4s ease-in-out;
}

.aluno-image-card:not(.on-hover) {
  opacity: 0.9;
}

.show-btns {
  color: rgb(173, 9, 9) !important;
  background-color: white;
}

.show-btns-down {
  color: rgb(8, 125, 66) !important;
  background-color: white;
  margin-right: 4px;
}
</style>
